var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component data-tree"},[_vm._l((_vm.data),function(node){return [(node)?_c('data-tree-node',{key:node.id,attrs:{"data":node}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }